import { render } from "./ShowInvoice.vue?vue&type=template&id=bd3b88f4&scoped=true"
import script from "./ShowInvoice.vue?vue&type=script&lang=js"
export * from "./ShowInvoice.vue?vue&type=script&lang=js"

import "./ShowInvoice.vue?vue&type=style&index=0&id=bd3b88f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3b88f4"]])

export default __exports__